import React, { useCallback } from 'react';
import { Tappable } from '@vectord/components';
import { useDispatch, batch } from 'react-redux';

import {
  COURSE_PAUSE_MODAL_STAGES,
  setCoursePauseManageModalStage,
  setSelectedRequest,
} from 'features/courseResume';

function ManageButton({ request }) {
  const dispatch = useDispatch();

  const handleManageButton = useCallback(() => {
    batch(() => {
      dispatch(setSelectedRequest(request));
      dispatch(
        setCoursePauseManageModalStage(COURSE_PAUSE_MODAL_STAGES.manage)
      );
    });
  }, [dispatch, request]);

  return (
    <Tappable
      onClick={handleManageButton}
      className="primary bold btn-small"
      noHighlight
    >
      Manage
    </Tappable>
  );
}

export default ManageButton;
